// extracted by mini-css-extract-plugin
export default {"zoomControls":"jaa-z","zoomControlButton":"kaa-z","zoomBanner":"laa-z","bannerButton":"maa-z","imageButton":"naa-z","zoom":"oaa-z","zoomContent":"paa-z"};